var _rect, _path, _g, _path2, _g2, _path3, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#FFF100"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_4589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_387_4589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 4H4V41H41V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_387_4589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5326 33.4956C22.1411 33.4956 21.7496 33.4956 21.4233 33.4303C16.2681 32.7778 13.4621 27.6878 15.8113 23.5767L22.4674 11.5044L29.254 23.5114C31.7337 27.8183 28.5362 33.1693 23.1199 33.4956C22.9242 33.4956 22.7284 33.4956 22.5326 33.4956Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_387_4589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 37,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4H4V41H41V4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_387_4589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5326 33.4956C22.1411 33.4956 21.7496 33.4956 21.4233 33.4303C16.2681 32.7778 13.4621 27.6878 15.8113 23.5767L22.4674 11.5044L29.254 23.5114C31.7337 27.8183 28.5362 33.1693 23.1199 33.4956C22.9242 33.4956 22.7284 33.4956 22.5326 33.4956Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_387_4589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 37,
    height: 37
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4H4V41H41V4Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_387_4589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7531 25.1429C28.4709 28.1446 26.187 31.3421 22.5327 31.5379C22.4021 31.5379 22.2716 31.5379 22.0759 31.5379C21.8148 31.5379 21.4886 31.5379 21.2275 31.4727",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_4589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrap);
export default __webpack_public_path__ + "static/media/wrap.c8e49823589f93ac3d6c6a709757f098.svg";
export { ForwardRef as ReactComponent };